//librerías
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

//context
import { AuthContext } from "../../../../context/AuthContext";

//componentes
import { Button, Container, Spinner } from "react-bootstrap";
import {
  faPen,
  faSquarePlus,
  faToggleOff,
  faToggleOn,
} from "@fortawesome/free-solid-svg-icons";

//interfaces
import { CentralesInterface } from "../../../../interfaces/CentralesInterface";

//hooks
import useFetch from "../../../../hooks/useFetch";
import { ColumnDef } from "@tanstack/react-table";
import CustomTable from "../../../Formularios/CustomTable/CustomTable";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import { toast } from "react-toastify";

//estilos
const classes = require("./CentralTable.module.css").default;

const CentralTable = () => {
  const authContext = useContext(AuthContext);
  //variables de estado
  const [centrales, setCentrales] = useState<CentralesInterface[]>();
  const { sendRequest, error, setError } = useFetch();
  const navigate = useNavigate();

  //Función que trata los clientes traídos de la BD.
  const transformData = useCallback((variable: any) => {
    setCentrales(variable.data);
  }, []);

  //Función que llama todos los clientes paginados
  useEffect(() => {
    sendRequest(
      {
        url: "/central",
      },
      transformData
    );
  }, [sendRequest, transformData]);

  //Función que desactiva a un usuario.
  const changeCentralStatus = useCallback(
    (idCentral: number) => {
      if (
        window.confirm(
          "¿Seguro que desea cambiar el estatus de la central? No podrá agregarla a clientes"
        )
      ) {
        sendRequest(
          {
            url: `/central/${idCentral}`,
            method: "DELETE",
          },
          (variable: any) => {
            setCentrales([]);
            toast.success("La central ha cambiado de estatus.", {
              position: "top-left",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            sendRequest(
              {
                url: "/central",
              },
              transformData
            );
          }
        );
      }
    },
    [sendRequest, transformData]
  );

  const columns = useMemo<ColumnDef<CentralesInterface>[]>(
    () => [
      {
        header: "#",
        accessorKey: "id",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
        enableColumnFilter: false,
      },
      {
        header: "Nombre",
        accessorFn: (row) => row.nombre,
        id: "Nombre",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
      },
      {
        header: "Estatus",
        cell: (info) => info.getValue(),
        accessorFn: (row) => (row.estatus ? "Activo" : "Inactivo"),
      },
      {
        header: "Acciones",
        cell: (info) => (
          <div className="btn-group" role="group" aria-label="Basic example">
            <Button
              title="Editar central"
              style={{ backgroundColor: "#2874A6", borderColor: "white" }}
              onClick={() =>
                navigate(
                  `/main/catalogos/centrales/edit/${info.row.original.id}`
                )
              }
              disabled={!authContext.tokenCan("Central:update")}
            >
              <FontAwesomeIcon icon={faPen} />
            </Button>
            {/** Botón para ver eliminar*/}
            <Button
              title={
                info.row.original.estatus
                  ? "Deshabilitar central"
                  : "Habilitar central"
              }
              style={{ backgroundColor: "#0d5475", borderColor: "white" }}
              onClick={() => changeCentralStatus(info.row.original.id)}
            >
              <FontAwesomeIcon
                icon={info.row.original.estatus ? faToggleOn : faToggleOff}
              />
            </Button>
          </div>
        ),
        footer: (props) => props.column.id,
      },
    ],
    [changeCentralStatus, navigate, authContext]
  );

  //Mientras se carga el contenido se muestra un spinner
  if (!centrales) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container>
      <h2>Lista de centrales</h2>
      {/** Botón para agregar usuario */}
      {authContext.tokenCan("Central:store") && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            title="Agregar una nueva central"
            style={{
              backgroundColor: "#21618C",
              borderColor: "white",
              marginBottom: "10px",
            }}
            onClick={() => navigate(`/main/catalogos/centrales/crear`)}
          >
            <FontAwesomeIcon icon={faSquarePlus} /> Nueva central
          </Button>
        </div>
      )}

      {/** Alerta de permisos */}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      <CustomTable
        {...{
          data: centrales,
          columns,
        }}
      />
    </Container>
  );
};

export default CentralTable;
